<template>
    <section class="pedido-steps contact-form" v-if="!form_succesfully_submitted">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="return d-block">
                        <router-link :to="route">
                            <img src="assets/img/backspace.svg" class="mb-5">
                        </router-link>
                        <router-link :to="route + 'cases-list'">
                            <a href="javascript:void(0)" class="btn-green mr-0 ml-2 btn-new-mobile">{{ $t("my_cases") }}</a>
                        </router-link>
                    </div>
                </div>
                <div class="section-title">
                    <h5 class="pull-left">{{ $t("title") }}</h5>
                </div>
            </div>
            <div class="row">
                
            <form>
                
                <div class="row mt-5">
                    <div class="col-md-3">
                        <div class="form-group" id="input-request">
                            <label>{{ $t("requests") }}</label>
                            <select name="request" v-model="data.request" @change="loadForm($event)">
                                <option v-for="(request,index) in this.requests" :key="index" :value="request.name">{{request.name}}</option>
                            </select>
                            <span class="required-span d-none">{{ $t("requests_mandatory") }}</span>
                        </div>
                    </div>
                    <div class="col-md-2" v-if="showForm">
                        <div class="form-group" id="input-type-of-request">
                            <label>{{ $t("type_of_request") }}</label>
                            <input type="text" name="type_of_request" v-model="data.type_of_request" disabled>
                        </div>
                    </div>
                    <div class="col-md-4" v-if="showForm">
                        <div class="form-group" id="input-account-name">
                            <label>{{ $t("account_name") }}</label>
                            <input type="text" name="account_name" v-model="data.account_name" disabled>
                            <span class="required-span d-none">{{ $t("account_name_mandatory") }}</span>
                        </div>
                    </div>
                    <div class="col-md-3" v-if="showForm && availableFields.description">
                        <div class="form-group" id="input-description">
                            <label>{{ $t("description") }}</label>
                            <select name="description" v-model="data.description" :required="availableFields.description.required">
                                <option v-for="(description,index) in this.descriptions" :key="index" :value="description">{{description}}</option>
                            </select>
                            <span class="required-span d-none">{{ $t("description_mandatory") }}</span>
                        </div>
                    </div> 
                </div>
                <div v-if="showForm">
                <div class="row mt-3">

                    <div class="col-md-4">
                        <div class="form-group" id="input-contact-name">
                            <label>{{ $t("contact_name") }}</label>
                            <input type="text" name="contact_name" v-model="data.contact_name">
                            <span class="required-span d-none">{{ $t("contact_name_mandatory") }}</span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group" id="input-contact-email">
                            <label>{{ $t("contact_email") }}</label>
                            <input type="email" name="contact_email" v-model="data.contact_email">
                            <span class="required-span d-none">{{ $t("contact_email_mandatory") }}</span>
                        </div>
                    </div>
                    <div class="col-md-3" v-if="availableFields.po_number">
                        <div class="form-group" id="input-po-number">
                            <label>{{ $t("po_number") }}</label>
                            <VueMultiselect
                                v-model="data.po_number"
                                :options="this.orders"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :internal-search="true"
                                :options-limit="100"
                                placeholder="Type to search"
                                label="purchase_order"
                                track-by="id"
                                :loading="isLoading"
                                :searchable="true"
                                @select="onSelectPoNumber"
                                @search-change="getOrdersByPONumber"
                            />
                            <span class="required-span d-none">{{ $t("po_number_mandatory") }}</span>
                        </div>
                    </div>
                    <div class="col-md-3" v-if="availableFields.plant_name">
                        <div class="form-group" id="input-plant-name">
                            <label title="{{ $t('plant_name_text') }}">{{ $t('plant_name') }}</label>                            
                            <input type="text" name="plant_name" v-model="data.plant_name" :required="availableFields.plant_name.required" disabled>
                            <span class="required-span d-none">{{ $t('plant_name_mandatory') }}</span>
                        </div>
                    </div>
                    
                    <div class="col-md-3" v-if="availableFields.invoice_number">
                        <div class="form-group" id="input-invoice-number">
                            <label>{{ $t("invoice_number") }}</label>
                            <input type="text" name="invoice-number" v-model="data.invoice_number" :required="availableFields.invoice_number.required">
                            <span class="required-span d-none">{{ $t("invoice_number_mandatory") }}</span>
                        </div>
                    </div>
                    <div class="col-md-3" v-if="availableFields.lot_number">
                        <div class="form-group" id="input-lot-number">
                            <label title="{{ $t('lot_number_text') }}">{{ $t('lot_number') }}</label>
                            <input type="text" name="lot_number" v-model="data.lot_number" :required="availableFields.lot_number.required">
                            <span class="required-span d-none">{{ $t('lot_number_mandatory') }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                        <div class="col-md-12" v-if="availableFields.product_number">
                            <div class="form-group" id="input-product-number">
                                <label title="{{ $t('product_number_text') }}">{{ $t('product_number') }}</label>
                                <VueMultiselect
                                    v-model="data.productsSelected"
                                    :options="this.products"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :internal-search="true"
                                    :options-limit="100"
                                    placeholder="Type to search"
                                    :custom-label="({ean, sku_name, material }) => `${ean} - ${sku_name} - ${material}`"
                                    track-by="ean"
                                    :loading="isLoading"
                                    :searchable="true"
                                    :multiple="availableFields.product_number_table"
                                    :taggable="false"
                                />
                                <span class="required-span d-none">{{ $t('product_number_mandatory') }}</span>
                            </div>
                        </div>
                        <div class="col-md-12" v-if="availableFields.product_number && availableFields.product_number_table">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ $t('product_table_code') }}</th>
                                        <th scope="col">{{ $t('product_table_name') }}</th>
                                        <th class="col-md-2" scope="col">{{ $t('product_table_lot_number') }}</th>
                                        <th class="col-md-2" scope="col">{{ $t('product_table_cases') }}</th>
                                        <th class="col-md-2" scope="col">{{ $t('product_table_price') }}</th>
                                        <th class="col-md-1" scope="col">{{ $t('product_table_total') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(product) in data.productsSelected" :key="product?.ean">
                                        <th scope="row">{{ product?.ean }} - {{ product?.material }}</th>
                                        <td>{{ product?.sku_name }}</td>
                                        <td><input type="text" v-model="product.lot_number"></td>
                                        <td><input type="number" v-model="product.cases"></td>
                                        <td><input type="number" v-model="product.pricePerCase"></td>
                                        <td>${{ calculateTotal(product) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <div class="form-group" id="input-comments">
                            <label>{{ $t('comments') }}</label>
                            <textarea type="text" name="comments" rows="6" v-model="data.comments"></textarea>
                            <span class="required-span d-none">{{ $t('comments_mandatory') }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-3"></div>
                <div class="row">
                    <div class="col-md-12">
                        <label>{{ $t('upload_images') }}</label>
                    </div>
                    <div class="col-md-4 mt-3">
                        <input id="att1" name="att1" ref="att1" type="file">
                    </div>
                    <div class="col-md-4 mt-3">
                        <input id="att2" name="att2" ref="att2" type="file">
                    </div>
                    <div class="col-md-4 mt-3">
                        <input id="att3" name="att3" ref="att3" type="file">
                    </div>
                </div>
                <div class="row mt-3"></div>
                <div class="row col-md-11" id="agree">
                    <div class="row col-md-11">
                        <label>
                            <div class="row">
                                <div class="col-md-1">
                                    <input class="mr-1" type="checkbox" name="agree_privacy_policy" id="agree_privacy_policy" required> 
                                </div>
                                <div class="col-md-11">
                                    {{ $t('accept_global_privary_policy') }}
                                    <a target="_blank" href="{{ $t('mccain_privacy_policy_link') }}">{{ $t('accept_terms_and_conditions') }}</a>
                                </div>
                            </div>
                        </label>
                    </div>
                    <div class="row col-md-11">
                        <span class="required-span d-none">{{ $t('accept_terms_and_conditions') }}</span>
                    </div>
                </div>
                <div class="row mt-5">
                    <a :href="route" class="btn-white">{{ $t("buttons.back_to_home") }}</a>
                    <a @click="cancel()" href="javascript:void(0)" class="btn-white">{{ $t("buttons.cancel") }}</a>
                    <a href="javascript:void(0)" @click="sendForm()" class="btn-send-form btn-green mr-0 ml-2">{{ (sendingForm) ? $t("buttons.sending") : $t("buttons.send") }} <div v-if="sendingForm" class="spinner-loading"></div></a>
                </div>
                </div>
            </form>
            </div>
        </div>
    </section>
    <section class="pedido-enviado contact-form" v-if="form_succesfully_submitted">
        <div class="container">
            <div class="row" >
                <div class="col-12">
                    <span class="check"><img src="assets/img/check.svg"></span>
                    <div class="listo">
                        <h3>¡{{ $t("ready") }}!</h3>
                        <p>{{ $t("text") }}</p>
                        <a href="javascript:void(0);" @click="reload()" class="btn-yellow">
                            {{ $t("buttons.ok") }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <vue-basic-alert :duration="300" :closeIn="1000000" ref="alert" />
</template>
<script>   
	import { route } from "../../enviroment.js" 
    import { ref } from 'vue';
    import $ from 'jquery'
    import axios from 'axios'
    export default {
        name: "ContactForm",
        i18n: {
            messages: {
                en: {
                    "title": "McCain Customer Contact Form",
                    "type_of_request": "Type of request",
                    "type_of_request_mandatory": "Type of request is mandatory",
                    "type_of_communication": "Type of communication",
                    "type_of_communication_mandatory": "Type of communication is mandatory",
                    "contact_name": "Customer name",
                    "contact_name_mandatory": "Name is mandatory",
                    "contact_email": "Customer email",
                    "contact_email_mandatory": "Email is mandatory",
                    "account_name": "Customer account name",
                    "account_name_mandatory": "Account name is mandatory",
                    "product_number_text": "Please indicate the full number of the product found on the front of the package, including the bag size and type of cut, for example, Home Chip Crinkle Cut.",
                    "product_number": "Product name",
                    "product_number_mandatory": "Product number is mandatory",
                    "comments": "Your comments",
                    "comments_mandatory": "Comments are mandatory",
                    "lot_number_text": "Please indicate the lot number that is usually printed on the back of the package.",
                    "lot_number": "Lot number",
                    "lot_number_mandatory": "Lot number is mandatory",
                    "upload_images": "Upload images",
                    "accept_global_privary_policy": "Please check the box to confirm that you agree with the treatment of personal data according to our Global Privacy Policy.",
                    "accept_terms_and_conditions": "You must accept the terms and conditions.",
                    "form_succesfully_submitted": "The form was successfully submitted.",
                    "requests": "Request",
                    "po_number": "PO Number",
                    "po_number_mandatory": "PO Number is mandatory",
                    "plant_name": "Plant Name",
                    "plant_name_mandatory": "Plant Name is mandatory",
                    "invoice_number": "Invoice Number",
                    "invoice_number_mandatory": "Invoice Number is mandatory",
                    "description": "Description",
                    "description_mandatory": "Description is mandatory",
                    "requests_mandatory": "Request is mandatory",
                    "ready": "Ready",
                    "text": "Your request has been sent to McCain for review.",
                    "product_table_code": "Code",
                    "product_table_name": "Name",
                    "product_table_cases": "Cases",
                    "product_table_price": "Price p/case",
                    "product_table_total": "Total",
                    "product_table_lot_number": "Lot Number",
                    "my_cases": "My Cases"
                },
                es: {
                    "title": "Formulario de Contacto de Clientes McCain",
                    "type_of_communication": "Tipo de comunicación",
                    "type_of_communication_mandatory": "El tipo de comunicacion es obligatorio",
                    "contact_name": "Nombre del cliente",
                    "contact_name_mandatory": "El nombre es obligatorio",
                    "contact_email": "Email del cliente",
                    "contact_email_mandatory": "El email es obligatorio",
                    "account_name": "Nombre de cuenta del cliente",
                    "account_name_mandatory": "El nombre de cuenta es obligatorio",
                    "product_number_text": "Por favor, indique el nombre completo del producto que se encuentra en la parte frontal del paquete, indicando el tamaño de la bolsa y el tipo de corte, por ejemplo, Home Chip Crinkle Cut.",
                    "product_number": "Nombre del producto",
                    "product_number_mandatory": "El nombre del producto es obligatorio",
                    "comments": "Sus comentarios",
                    "comments_mandatory": "Los comentarios son obligatorios",
                    "lot_number_text": "Por favor, indique el número de lote que se imprime normalmente en la parte posterior del paquete.",
                    "lot_number": "Número de lote",
                    "lot_number_mandatory": "El numero de lote es obligatorio",
                    "upload_images": "Subir imágenes",
                    "accept_global_privary_policy": "Por favor, marque la casilla para confirmar que está de acuerdo con el tratamiento de los datos personales de acuerdo con nuestra Política Global de Privacidad",
                    "accept_terms_and_conditions": "Debe aceptar los terminos y condiciones",
                    "form_succesfully_submitted": "El formulario se envio correctamente",
                    "requests": "Solicitud",
                    "type_of_request": "Tipo de solicitud",
                    "type_of_request_mandatory": "El tipo de solicitud es obligatorio",
                    "po_number": "Número de PO",
                    "po_number_mandatory": "El número de PO es obligatorio",
                    "plant_name": "Nombre de la planta",
                    "plant_name_mandatory": "El nombre de la planta es obligatorio",
                    "invoice_number": "Número de factura",
                    "invoice_number_mandatory": "El número de factura es obligatorio",
                    "description": "Descripción",
                    "description_mandatory": "La descripción es obligatoria",
                    "requests_mandatory": "La solicitud es obligatoria",
                    "ready": "Listo",
                    "text": "Tu solicitud fue enviada a McCain para revisión.",
                    "product_table_code": "Codigo",
                    "product_table_name": "Nombre",
                    "product_table_cases": "Unidades",
                    "product_table_price": "Precio p/unidad",
                    "product_table_total": "Total",
                    "product_table_lot_number": "Número de lote",
                    "my_cases": "Mis Casos"
                }
            }
        },
        setup() {
            const month = ref({ 
                month: new Date().getMonth(),
                year: new Date().getFullYear()
            });
            return {
                month,
            }
        },
        data() {
            return {
                route:route,
                data: {
                    type_of_request: '',
                    contact_name: '',
                    contact_email: '',
                    account_name: '',
                    productsSelected: [],
                    comments: '',
                    lot_number: '',
                    invoice_number: '', 
                    plant_name: '',
                    po_number: '',
                    plant_number: '',
                },
                availableFields: this.defaultForm(),
                requests: [],
                showForm: false,
                isLoading: true,
                sendingForm: false,
                orders: [],
                products: [],
                descriptions: [],
                form_succesfully_submitted: false,
            }
        },
        created(){
            this.getRequests()
            this.getUser()
            this.getOrdersByPONumber()
        },
        methods: {
            calculateTotal(product) {
                const cases = parseFloat(product.cases) || 0;
                const pricePerCase = parseFloat(product.pricePerCase) || 0;
                const total = cases * pricePerCase;
                return total.toFixed(2);
            },
            getUser(){
                axios.get(this.$woe_api_uri + '/user'
                ).then((response) => {        
                    this.user = response.data.data.user                    
                }).catch((error) => {
                    if (error.code == "ERR_BAD_REQUEST"){
                        location.href= route + "login";
                    } else {
                        this.showAlert('warning',`${this.$t('caution')}!`, error.response.data.error.message);
                    }
                });
            },
            showAlert(type, title, message) {
                this.$refs.alert.showAlert(
                    type, // There are 4 types of alert: success, info, warning, error
                    message, // Message of the alert
                    title, // Header of the alert
                    { 
                        iconSize: 35, // Size of the icon (px)
                        iconType: 'solid', // Icon styles: now only 2 styles 'solid' and 'regular'
                        position: 'top right' // Position of the alert 'top right', 'top left', 'bottom left', 'bottom right' 
                    } 
                )
            },
            getRequests() {
                this.requests = [
                    { 
                        id: 2,
                        name: "Accounting Services",
                        type_of_request: "Delivery",
                        description: [
                            'Account Statements',
                            'Credit Note Request',
                            'Credit Limit'
                        ]
                    },
                    { 
                        id: 3,
                        name: "Compliance/Customs",
                        type_of_request: "Delivery",
                        description: [
                            'Compliance Audit',
                            'Customs and International Regulations',
                            'Environmental query',
                            'Free Trade Agreements',
                            'Import/Export Query',
                            'Policies and Procedures Request',
                            'Product Specification',
                            'Quality Certifications',
                            'Sustainability'
                        ]
                    },
                    { 
                        id: 4,
                        name: "Customer Service",
                        type_of_request: "Delivery",
                        description: [
                            'Delivery Query',
                            'Digital Platforms', 
                            'Document Inquiry',
                            'Purchase Orders',
                            'Transportation'
                        ]
                    },
                    { 
                        id: 5,
                        name: "Food Safety",
                        type_of_request: "Complaint",
                        description: [
                            'Product safety',
                            'Production / Expiration date',
                            'Product Compliance',
                            'Shelf life'
                        ]
                    },
                    { 
                        id: 6,
                        name: "Logistics Claims",
                        type_of_request: "Complaint",
                        description: [
                            'Damages',
                            'Demurrages',
                            'Product Quality',
                            'Shortages',
                            'Temperature abuse',
                        ]
                    },
                    { 
                        id: 7,
                        name: "Commercial Inquiries",
                        type_of_request: "Delivery",
                        description: [
                            'Culinary Support',
                            'Demand Forecasting',
                            'Innovation',
                            'Price Inquiry',
                            'Product Tasting/Trainnings',
                            'Samples'
                        ]
                    },
                    { 
                        id: 8,
                        name: "Compliment",
                        type_of_request: "Compliment",
                        description: []
                    }
                ];
            },
            validateForm(){
                let errors = 0;

                $('#input-contact-name .required-span').addClass('d-none');
                $('#input-contact-email .required-span').addClass('d-none');
                $('#input-description .required-span').addClass('d-none');
                $('#input-po-number .required-span').addClass('d-none');
                $('#input-invoice-number .required-span').addClass('d-none');
                $('#input-lot-number .required-span').addClass('d-none');
                $('#input-comments .required-span').addClass('d-none');
                $('#agree .required-span').addClass('d-none');

                //Valido contact name
                if (this.data.contact_name == ""){
                    $('#input-contact-name .required-span').removeClass('d-none')
                    $('#input-contact-name input').addClass('required')
                    errors++;
                } else {
                    $('#input-contact-name .required-span').addClass('d-none')
                    $('#input-contact-name input').removeClass('required')
                }
                
                //Valido input-contact-email
                if (this.data.contact_email == ""){
                    $('#input-contact-email .required-span').removeClass('d-none')
                    $('#input-contact-email input').addClass('required')
                    errors++;
                } else {
                    $('#input-contact-email .required-span').addClass('d-none')
                    $('#input-contact-email input').removeClass('required')
                }

                //Valido input-description
                if (this.availableFields?.description?.required && (this.data.description == undefined || this.data.description == "")){
                    $('#input-description .required-span').removeClass('d-none')
                    $('#input-description select').addClass('required')
                    errors++;
                } else {
                    $('#input-description .required-span').addClass('d-none')
                    $('#input-description select').removeClass('required')
                }

                //po number
                if (this.availableFields?.po_number?.required && (this.data.po_number == undefined || this.data.po_number == "")){
                    $('#input-po-number .required-span').removeClass('d-none')
                    $('#input-po-number .multiselect__tags').addClass('required')
                    errors++;
                } else {
                    $('#input-po-number .required-span').addClass('d-none')
                    $('#input-po-number .multiselect__tags').removeClass('required')
                }

                //input-product-number
                if (this.availableFields?.product_number?.required && (this.data.productsSelected == undefined || this.data.productsSelected == "")){
                    $('#input-product-number .required-span').removeClass('d-none')
                    $('#input-product-number .multiselect__tags').addClass('required')
                    errors++;
                } else {
                    $('#input-product-number .required-span').addClass('d-none')
                    $('#input-product-number .multiselect__tags').removeClass('required')
                }

                //invoice_number
                if (this.availableFields?.invoice_number?.required && this.data.invoice_number == ""){
                    $('#input-invoice-number .required-span').removeClass('d-none')
                    $('#input-invoice-number input').addClass('required')
                    errors++;
                } else {
                    $('#input-invoice-number .required-span').addClass('d-none')
                    $('#input-invoice-number input').removeClass('required')
                }

                //lot_number
                if (this.availableFields?.lot_number?.required && this.data.lot_number == ""){
                    $('#input-lot-number .required-span').removeClass('d-none')
                    $('#input-lot-number input').addClass('required')
                    errors++;
                } else {
                    $('#input-lot-number .required-span').addClass('d-none')
                    $('#input-lot-number input').removeClass('required')
                }

                //Valido input-comments
                if (this.data.comments == ""){
                    $('#input-comments .required-span').removeClass('d-none')
                    $('#input-comments textarea').addClass('required')
                    errors++;
                } else {
                    $('#input-comments .required-span').addClass('d-none')
                    $('#input-comments textarea').removeClass('required')
                }

                //Valido gree
                if (!$('#agree_privacy_policy').is(':checked')) {
                    $('#agree .required-span').removeClass('d-none')
                    $('#agree input').addClass('required')
                    errors++;
                } else {
                    $('#agree .required-span').addClass('d-none')
                    $('#agree input').removeClass('required')
                }

                if (errors>0) {
                    return false;
                }

                return true;
            },
            sendForm(){
                if (!this.validateForm()) {
                    return false;
                }
                if (this.sendingForm) {
                    $('.btn-send-form').addClass('disabled');
                    return false;
                }
                this.sendingForm = true;
                let dataForm = new FormData();
                Object.keys(this.data).forEach((key) => {
                    if (key == 'po_number') {
                        dataForm.append(key, this.data.po_number.id);
                    } else if (key == 'productsSelected') {
                        let products = [];
                        if (this.data.request == 'Logistics Claims') {
                            products = this.data[key].map(product => {
                                return {
                                    material: product.material,
                                    ean: product.ean,
                                    cases: product.cases,
                                    pricePerCase: product.pricePerCase,
                                    lot_number: product.lot_number,
                                }
                            });
                        } else {
                            products = [{
                                material: this.data.productsSelected.material,
                                ean: this.data.productsSelected.ean,
                                cases: this.data.productsSelected.cases,
                                pricePerCase: this.data.productsSelected.pricePerCase,
                                lot_number: this.data.lot_number,
                            }];
                        }
                        dataForm.append(key, JSON.stringify(products));
                    } else {
                        dataForm.append(key, this.data[key]);
                    }
                });
                dataForm.append(`att1`, this.$refs.att1.files[0]);
                dataForm.append(`att2`, this.$refs.att2.files[0]);
                dataForm.append(`att3`, this.$refs.att3.files[0]);
                axios.post(this.$woe_api_uri + '/contact', dataForm,
                ).then(() => {
                    this.form_succesfully_submitted = true;
                })
                .catch((error) => {
                    this.showAlert('warning',`${this.$t('caution')}!`, error?.response?.data?.error?.message ?? this.$t("unexpected_error"));
                }).finally(() => {
                    this.sendingForm = false;
                });
            },
            getRequestById(id) {
                return this.requests.find((request) => request.id == id);
            },
            getRequestByName(name) {
                return this.requests.find((request) => request.name == name);
            },
            loadForm() {
                const request = this.getRequestByName(event.target.value);
                this.data = {...this.data, ...this.defaultValues()};
                this.availableFields = this.getFormFieldsByRequestId(request.id);
                this.products = [];
                this.data.type_of_request = request.type_of_request;
                this.data.account_name = this.user?.name;
                this.descriptions = request.description;
                this.showForm = true;
            },
            getFormFieldsByRequestId(id) {
                const data = [
                    {
                        field: 'po_number',
                        required: [6],
                        ids: [2, 3, 4, 5, 6, 7]
                    },
                    {
                        field: 'product_number',
                        required: [5,6],
                        ids: [2, 3, 4, 5, 6, 7]
                    },
                    {
                        field: 'product_number_table',
                        required: [6],
                        ids: [6]
                    },
                    {
                        field: 'invoice_number',
                        required: [6],
                        ids: [2, 3, 4, 5, 6, 7]
                    },
                    {
                        field: 'lot_number',
                        required: [5],
                        ids: [5]
                    },
                    {
                        field: 'plant_name',
                        required: [4,5,6],
                        ids: [4,5,6]
                    },
                    {
                        field: 'description',
                        required: [2, 3, 4, 5, 6, 7],
                        ids: [2, 3, 4, 5, 6, 7]
                    }
                ];
                let dataForm = {};
                data.forEach((field) => {
                    if (field.required.includes(Number(id))) {
                        dataForm[field.field] = {
                            required: true
                        };
                    } else if (field.ids.includes(Number(id))) {
                        dataForm[field.field] = {
                            required: false
                        }
                    }
                });
                return dataForm;
            },
            defaultForm() {
                return {
                    product_number: {
                        required: false
                    },
                    product_number_table: {
                        required: false
                    },
                    lot_number: {
                        required: false
                    },
                    invoice_number: {
                        required: false
                    },
                    plant_name: {
                        required: false
                    },
                    po_number: {
                        required: false
                    }
                }
            },
            defaultValues() {
                return {
                    type_of_request: '',
                    contact_name: '',
                    contact_email: '',
                    account_name: '',
                    product_number: '',
                    product_number_table: '',
                    comments: '',
                    lot_number: '',
                    invoice_number: '', 
                    plant_name: '',
                    po_number: '',
                    plant_number: '',
                    productsSelected: [],
                }
            },
            cancel() {
                this.showForm = false;
                this.data = this.defaultValues();
            },
            async getOrdersByPONumber(query = '') {
                if (query.length < 4 && query.length != 0) {
                    return;
                }
                const result = this.orders.find((order) => order.purchase_order.toLowerCase().includes(query.toLowerCase()));
                if (result) {
                    return;
                }
                this.isLoading = true
                axios.post(this.$woe_api_uri + '/order', {
                    'page': 1,
                    'size': 10,
                    'purchase_order': query,
                }).then((response) => {
                    this.orders = response.data.data.orders
                    this.isLoading = false
                })
                .catch((error) => {
                    if (error.code == "ERR_BAD_REQUEST"){
                        location.href = "/login";
                    } else {
                        this.showAlert('warning',`${this.$t("caution")}!`, error.response.data.error.message);
                    }
                });
            },
            getOrderProductsByOrder(order) {
                axios.post(this.$woe_api_uri + '/order/items', 
                    {
                        'id': order.id
                    }
                ).then((response) => {
                    const products = response.data.data.items 
                    .map((product) => {
                        return {
                            ...product,
                            ...{ 
                                lot_number: '',
                                cases: 0, 
                                pricePerCase: 0,
                            }
                        }
                    });

                    this.products = products;
                })
                .catch((error) => {
                    this.showAlert('warning',`${this.$t("caution")}!`, error.response.data.error.message);
                });
            },
            onSelectPoNumber(order) {
                this.products = [];
                this.data.product_number_table = '';
                this.data.productsSelected = [];
                this.getOrderProductsByOrder(order);
                this.data.plant_name = `${order.plant_id} - ${order.plant_name}`;
                this.data.plant_number = order.plant_id;
            },
            reload() {
                this.cancel();
                window.location.reload();
            },
        }
    }
</script>